export default [
  {
    path: '/tool-ranking/index',
    name: 'Index',
    component: () => import('@/views/tool-ranking/index'),
    meta: {
      title: '广州一模成绩->省排名转换-高考直通车'
    }
  },
  {
    path: '/tool-ranking/result',
    name: 'result',
    component: () => import('@/views/tool-ranking/result'),
    meta: {
      title: '广州一模成绩->省排名转换-高考直通车'
    }
  }
]
